// extracted by mini-css-extract-plugin
export default {"classroomCard":"ClassroomItem_classroomCard__0bvR1","left":"ClassroomItem_left__sjh4q"};